/* Lunaire - compartilhar carrinho por link */
(function () {
  var PARAM = 'carrinho';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  var shared = new URLSearchParams(location.search).get(PARAM);
  if (shared) {
    var items = shared.split(',').map(function (p) {
      var a = p.split(':');
      return { id: parseInt(a[0], 10), quantity: Math.max(1, parseInt(a[1] || '1', 10) || 1) };
    }).filter(function (i) { return i.id > 0; });
    if (items.length) {
      document.documentElement.style.opacity = '.4';
      fetch(root + 'cart/clear.js', { method: 'POST', headers: JSONH })
        .then(function () {
          return fetch(root + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: items }) });
        })
        .then(function (r) {
          if (r.ok) return;
          return items.reduce(function (chain, it) {
            return chain.then(function () {
              return fetch(root + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [it] }) }).catch(function () {});
            });
          }, Promise.resolve());
        })
        .catch(function () {})
        .then(function () { location.replace(root + 'cart'); });
      return;
    }
  }

  var css = '.kv-share-cart{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin-top:10px;padding:13px 16px;background:transparent;border:1px solid #111;color:#111;font-family:inherit;font-size:12px;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;transition:background .2s,color .2s}' +
    '.kv-share-cart:hover{background:#111;color:#fff}' +
    '.kv-share-cart svg{width:16px;height:16px;flex:none}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';
  var LABEL = 'Compartilhar carrinho';

  function inject() {
    document.querySelectorAll('.cart__ctas, .cart__checkout-wrapper').forEach(function (c) {
      if (c.parentNode.querySelector('.kv-share-cart')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kv-share-cart';
      b.innerHTML = ICON + '<span>' + LABEL + '</span>';
      c.insertAdjacentElement('afterend', b);
    });
  }

  function flash(b, msg) {
    var s = b.querySelector('span');
    s.textContent = msg;
    setTimeout(function () { s.textContent = LABEL; }, 2500);
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (res) {
      var t = document.createElement('textarea');
      t.value = text;
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t);
      res();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kv-share-cart');
    if (!b) return;
    e.preventDefault();
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { flash(b, 'Seu carrinho está vazio'); return; }
        var map = {}, order = [];
        cart.items.forEach(function (i) {
          if (!map[i.variant_id]) { map[i.variant_id] = 0; order.push(i.variant_id); }
          map[i.variant_id] += i.quantity;
        });
        var list = order.map(function (id) { return id + ':' + map[id]; }).join(',');
        var url = location.origin + root + 'cart?' + PARAM + '=' + list;
        var text = 'Olha o carrinho que eu montei na Lunaire:';
        if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
          navigator.share({ title: 'Lunaire', text: text, url: url }).catch(function () {});
        } else {
          copy(url).then(function () { flash(b, 'Link copiado!'); });
        }
      })
      .catch(function () { flash(b, 'Tente novamente'); });
  });

  inject();
  new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
})();
